import { withInjection } from "/src/components/ui/util/with-injection";
import { APP_DEP } from "/src/config/configure-dependencies";
import { CardSettings, CardSettingsProps } from "/src/pages/card-settings/CardSettings";

export const InjectedCardSettings = withInjection<
  CardSettingsProps,
  "cardManagementService" | "externalBizbankService"
>(CardSettings, {
  cardManagementService: APP_DEP.CARD_MANAGEMENT_SERVICE,
  externalBizbankService: APP_DEP.EXTERNAL_BIZBANK_SERVICE,
});
